import React, { useRef, useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "components/Attachments/UploadAttachment.css";

import Sidebar from "../sidebar/Sidebar";
import WorkoutAttachments from "../Attachments/WorkoutAttachments";
import ErrorModal from "../common/ErrorModal/ErrorModal";
import VideoUploadPopup from "./VideoUploadPopup";
import ProgressBar from "@ramonak/react-progress-bar";

// Import new components
import WorkoutTabs from "./components/WorkoutTabs";
import ExerciseSetModal from "./components/ExerciseSetModal";
import QuickEditModal from "./components/QuickEditModal";
import CreateExerciseModal from "./components/CreateExerciseModal";
import ExerciseSelectionModal from "./components/ExerciseSelectionModal";
import MergeExerciseModal from "./components/MergeExerciseModal";

// Import hooks
import { useWorkoutState } from "./hooks/useWorkoutState";
import { useExerciseOperations } from "./hooks/useExerciseOperations";

// Import constants and services
import { BASE_URL_MEDIA } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';
import { Services } from "../../api/Services";
import { ToastContainer } from "react-toastify";

import imagee from "../../images/placeholder.png";
import placholder from "../../images/placeholder.png";

const CreateWorkout = () => {
  const state = useWorkoutState();
  const fileInputRef = useRef(null);
  // Track whether the video upload popup is for workout or exercise
  const [videoUploadContext, setVideoUploadContext] = useState(null); // 'workout' | 'exercise' | null
  // Hold the exercise payload until video upload completes
  const pendingExerciseRef = useRef(null);

  const {
    pid,
    wid,
    widd,
    isLoading,
    setisLoading,
    isLoad,
    workoutViewType,
    setWorkoutViewType,
    reorder,
    setReorder,
    addType,
    setAddType,
    detailset,
    setDetailSet,
    quickset,
    setQuickSet,
    isdisable,
    setisdisable,
    cmodal,
    setCmodal,
    weeks,
    setWeeks,
    excercisemodal,
    setExcerciseModal,
    selectedDays,
    setSelectedDays,
    apiexercises,
    setApiExercises,
    mergeexercises,
    setMergeExercises,
    selectedExercise,
    setSelectedExercise,
    selectedExerciseEmom,
    setSelectedExerciseEmom,
    setValues,
    setSetValues,
    excerciseList,
    setExerciseList,
    image,
    setImage,
    selectedFields,
    setSelectedFields,
    selectedFile,
    setSelectedFile,
    mvideo,
    setMvideo,
    mergeId,
    setMergeId,
    selectedimage,
    setSelectedimage,
    newExercise,
    setNewExercise,
    merge,
    setMerge,
    removeMerge,
    setRemoveMerge,
    selectedExerciseIds,
    setSelectedExerciseIds,
    selectedExerciseremoveIds,
    setSelectedExerciseremoveIds,
    inputValues,
    setInputValues,
    confirmActionModal,
    setConfirmActionModal,
    actionModalMessage,
    setActionModalMessage,
    selectedActionObj,
    setSelectedActionObj,
    selectedActionObj2,
    setSelectedActionObj2,
    selectedActionObjType,
    setSelectedActionObjType,
    actionButtonTitle,
    setActionButtonTitle,
    progress,
    setProgress,
    isUpLoading,
    setIsUpLoading,
    showVideoUploadPopup,
    setShowVideoUploadPopup,
    selectedVideoFile,
    setSelectedVideoFile,
    selectedVideoUrl,
    setSelectedVideoUrl,
    updateVideoLinKWorkout,
    setUpdateVideoLinKWorkout,
    workoutData,
    setWorkoutData,
    workoutExercise,
    setWorkoutExercise,
    generalFields,
    setGeneralFields,
    keyword,
    setkeyword,
  } = state;

  // Exercise operations hook
  const exerciseOps = useExerciseOperations(state, workoutDetail);

  let emomIterations = workoutData?.duration / apiexercises.length;

  const showError = (error) => {
    return toast.error(error, {
      autoClose: 3000,
      pauseOnHover: true,
      draggable: true,
    });
  };

  // Utility functions
  const formateSetsinputs = (sets) => {
    const uniqueValues = {};
    sets.forEach((set) => {
      set.inputs.forEach((input) => {
        const fieldName = input.field_name;
        const value = input.value;
        if (!uniqueValues[fieldName]) {
          uniqueValues[fieldName] = new Set();
        }
        uniqueValues[fieldName].add(value);
      });
    });

    const formattedValues = {};
    for (const fieldName in uniqueValues) {
      formattedValues[fieldName] = Array.from(uniqueValues[fieldName]);
    }
    return formattedValues;
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedExercises = [...apiexercises];
    const [movedExercise] = reorderedExercises.splice(result.source.index, 1);
    reorderedExercises.splice(result.destination.index, 0, movedExercise);
    setApiExercises(reorderedExercises);
  };

  const payLoad = {
    workout_id: wid || widd,
    exercises: apiexercises?.map((exercise, index) => ({
      id: exercise.id,
      order: index,
    })),
  };

  // File handling
  const handleImageFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setisLoading(true);
    setSelectedimage(URL.createObjectURL(event.target.files[0]));
  };

  const handleSelectVideo = (e) => {
    const file = e.target.files[0];
    if (file) {
      const videoUrl = URL.createObjectURL(file);
      setSelectedVideoFile(file);
      setSelectedVideoUrl(videoUrl);
      console.log("Selected video file:", videoUrl);
    }
  };

  const handleVideoUploaded = (videoUrl) => {
    // Workout-level video upload completed
    console.log("Video uploaded:", videoUrl);
    setWorkoutData(prev => ({
      ...prev,
      video: videoUrl
    }));
    setShowVideoUploadPopup(false);
    setSelectedVideoFile(null);
    setUpdateVideoLinKWorkout(true);
    setVideoUploadContext(null);
  };

  // Exercise-level video upload completed: now create the exercise
  const handleExerciseVideoUploaded = async (videoUrl) => {
    const pending = pendingExerciseRef.current;
    if (!pending) {
      setShowVideoUploadPopup(false);
      setVideoUploadContext(null);
      return;
    }
    const exerciseToAdd = {
      name: pending.name,
      video: videoUrl,
      fields: pending.fields,
    };

    setShowVideoUploadPopup(false);
    setVideoUploadContext(null);
    setisLoading(true);
    try {
      const result = await Services.createExercise(exerciseToAdd);
      if (result.status === 200) {
        const newex = {
          workout_id: wid || widd,
          program_id: pid,
          exercises: [
            {
              exercise: {
                order: workoutExercise.exercises.length,
                exercise_id: result?.data?.data.id,
                name: result?.data?.data.name,
              },
            },
          ],
        };
        await addExcercises(newex);
        // Reset form state
        setNewExercise({ name: "", video: "" });
        setSelectedFields([]);
        setCmodal(false);
        toast.success(result?.data?.message || "Exercise created", {
          autoClose: 1500,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setisLoading(false);
      pendingExerciseRef.current = null;
      // Clear selected video state
      setSelectedVideoFile(null);
      setSelectedVideoUrl(null);
    }
  };

  useEffect(() => {
    if (updateVideoLinKWorkout) {  
      EditWork(workoutData);
    }
  }, [updateVideoLinKWorkout]);

  const handleDivClick = () => {
    console.log("DIV CLICK TRIGGERED");
    fileInputRef.current?.click();
  };

  // Form handlers
  const handleInputsChange = (event) => {
    const { name, value } = event.target;
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [name]: value,
    }));
  };

  const handleAddType = (item) => {
    setAddType((pre) => !pre);
    setDetailSet(item);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setWorkoutData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if ((name === "start_date" || name === "end_date")) {
      let startDateVal = name === "start_date" ? value : workoutData.start_date;
      let endDateVal = name === "end_date" ? value : workoutData.end_date;

      if (startDateVal) {
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const startDay = daysOfWeek[new Date(startDateVal).getDay()];
        let endDay = "";
        if (endDateVal) {
          endDay = daysOfWeek[new Date(endDateVal).getDay()];
        }
        if (startDay === endDay || endDay === "") {
          setSelectedDays([]);
          setSelectedDays([startDay]);
          setWorkoutData((prevWorkoutData) => ({
            ...prevWorkoutData,
            days: startDay,
          }));
        }
      }
    }
  };

  const handleSetChange = (setIndex, inputIndex, newValue) => {
    const updatedExercise = { ...selectedExercise };
    updatedExercise.sets[setIndex].inputs[inputIndex].value = parseFloat(newValue);
    setSelectedExercise(updatedExercise);
  };

  const handleSetChangeEmom = (setIndex, inputIndex, newValue) => {
    const updatedValues = [...setValues];
    if (updatedValues[setIndex] && updatedValues[setIndex][inputIndex]) {
      updatedValues[setIndex][inputIndex].value = parseFloat(newValue);
      setSetValues(updatedValues);
      const updatedExerciseEmom = { ...selectedExerciseEmom };
      updatedExerciseEmom.sets[setIndex].inputs[inputIndex].value = parseFloat(newValue);
      setSelectedExerciseEmom(updatedExerciseEmom);
    }
  };

  const handleDayClick = (value) => {
    let updatedSelectedDays;
    if (selectedDays.includes(value)) {
      updatedSelectedDays = selectedDays.filter((v) => v !== value);
    } else {
      updatedSelectedDays = [...selectedDays, value];
    }
    setSelectedDays(updatedSelectedDays);
    setWorkoutData((prevWorkoutData) => ({
      ...prevWorkoutData,
      days: updatedSelectedDays.join(","),
    }));
  };

  // Exercise management
  const toggleExercise = (exercise) => {
    const isSelected = isSelectedExercise(exercise.id);
    if (isSelected) {
      removeExercise(exercise.id);
    } else {
      addExercise(exercise);
    }
  };

  const isSelectedExercise = (exerciseId) => {
    return workoutExercise?.exercises?.some(
      (exercise) => exercise.exercise.exercise_id === exerciseId
    );
  };

  const removeExercise = (exerciseId) => {
    setWorkoutExercise((prevData) => ({
      ...prevData,
      exercises: prevData.exercises.filter(
        (exercise) => exercise.exercise.exercise_id !== exerciseId
      ),
    }));
  };

  const addExercise = (exercise) => {
    const newExercise = {
      exercise: {
        order: workoutExercise.exercises.length,
        exercise_id: exercise.id,
        name: exercise?.name,
      },
    };
    setWorkoutExercise((prevData) => ({
      ...prevData,
      exercises: [...prevData.exercises, newExercise],
    }));
  };

  const showExcercise = () => {
    setExcerciseModal(true);
  };

  // API calls
  const reOrderexcercise = async (updatedExercises = null) => {
    try {
      const exercisesToUse = updatedExercises || apiexercises;
      console.log('reOrderexcercise - using:', updatedExercises ? 'updatedExercises' : 'apiexercises', exercisesToUse);
      const payload = {
        workout_id: wid || widd,
        exercises: exercisesToUse?.map((exercise, index) => ({
          id: exercise.id,
          order: index,
        })),
      };
      const result = await Services.reOrderExercises(payload);
      if (result.status === 200) {
        toast.success(result.data.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        setReorder(true);
        // Refresh workout details to get updated exercises list
        workoutDetail(wid || widd);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const programmDetail = async (program_id, day, week) => {
    try {
      const result = await Services.getProgrammDetail(program_id, day, week);
      if (result.status === 200) {
        const weekss = Array.from(
          { length: result?.data?.data?.number_of_weeks },
          (_, index) => index + 1
        );
        setWeeks(weekss);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const generalField = async () => {
    try {
      const result = await Services.getgeneralFields();
      if (result.status === 200) {
        setGeneralFields(result?.data?.data);
      } else {
        toast.error("Some error", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const allExcercises = async (current_page = 1, keyword) => {
    try {
      const result = await Services.getExcerciseList(current_page, keyword);
      if (result.status === 200) {
        setExerciseList(result?.data?.data);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addExcercises = async (data) => {
    setisLoading(true);
    try {
      const result = await Services.addWorkoutexcercises(data);
      if (result.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1500,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => {
          setWorkoutExercise((prevData) => ({
            ...prevData,
            exercises: [],
          }));
          workoutDetail(wid || widd);
          setExcerciseModal(false);
          allExcercises(1);
        }, 1000);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const uploadimg = async (data) => {
    try {
      const result = await Services.uploadImage(data);
      if (result.status === 200) {
        setImage(result?.data?.data?.image);
        setWorkoutData((prevData) => ({
          ...prevData,
          image: result?.data?.data?.image,
        }));
        setSelectedFile(null);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  if (selectedFile) {
    const uploadimagee = new FormData();
    uploadimagee.append("image", selectedFile);
    uploadimg(uploadimagee);
  }

  const handleNewExerciseChange = (event) => {
    const { name, value } = event.target;
    setNewExercise((prevExercise) => ({
      ...prevExercise,
      [name]: value,
    }));
  };

  const handleFieldSelection = (field) => {
    if (
      selectedFields.some(
        (selectedField) => selectedField.measurement_id === field.measurement_id
      )
    ) {
      setSelectedFields((prevSelectedFields) =>
        prevSelectedFields.filter(
          (selectedField) =>
            selectedField.measurement_id !== field.measurement_id
        )
      );
    } else if (selectedFields.length < 2) {
      setSelectedFields((prevSelectedFields) => [...prevSelectedFields, field]);
    }
  };

  const createNewExercise = async () => {
    if (newExercise.name.trim() === "") {
      toast.error("please enter exercise name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (selectedFields.length === 0) {
      toast.error("please select atleast one field", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (selectedVideoFile) {
      // If a local video file is selected, upload first using the popup, then create exercise
      pendingExerciseRef.current = {
        name: newExercise.name,
        fields: selectedFields,
      };
      setVideoUploadContext('exercise');
      setShowVideoUploadPopup(true);
      // Do not proceed to API call here; it will continue in handleExerciseVideoUploaded
    } else {
      const exerciseToAdd = {
        name: newExercise.name,
        video: newExercise.video,
        fields: selectedFields,
      };

      setisLoading(true);
      try {
        const result = await Services.createExercise(exerciseToAdd);
        if (result.status === 200) {
          const newex = {
            workout_id: wid || widd,
            program_id: pid,
            exercises: [
              {
                exercise: {
                  order: workoutExercise.exercises.length,
                  exercise_id: result?.data?.data.id,
                  name: result?.data?.data.name,
                },
              },
            ],
          };
          addExcercises(newex);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
      }

      setNewExercise({
        name: "",
        video: "",
      });
      setSelectedFields([]);
      setCmodal(false);
    }
  };

  async function workoutDetail(workout_id) {
    try {
      const result = await Services.getWorkoutDetail(workout_id);
      if (result.status === 200) {
        setApiExercises(result?.data?.data?.exercises);
        setMergeExercises(result?.data?.data?.merged_exercises_collections);
        const newInputValues = {};

        result?.data?.data?.exercises?.forEach((exercise, exerciseIndex) => {
          exercise?.sets[0].inputs?.forEach((input, inputIndex) => {
            newInputValues[
              `${exercise.id}_${exercise.sets[0].id}_${input.id}`
            ] = input.value || "";
          });
        });

        setInputValues(newInputValues);
        setSelectedDays(result?.data?.data?.day.split(","));

        const formattedWorkoutData = {
          days: result?.data?.data?.day,
          start_date: result?.data?.data.start_date,
          group_id: result?.data?.data.group_id,
          image: result?.data?.data?.image,
          date: result?.data?.data.date,
          duration: result?.data?.data.duration,
          workout_type: result?.data?.data.workout_type,
          week: result?.data?.data.week,
          video: result?.data?.data.video,
          program_id: result?.data?.data.program_id,
          workout_id: result?.data?.data?.id,
          end_date: result?.data?.data.end_date,
          name: result?.data?.data.name,
          desc: result?.data?.data.desc,
          schedule_type: result?.data?.data.schedule_type || "fixed",
        };

        setWorkoutData(formattedWorkoutData);
      } else {
        toast.error(result?.data?.error, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const CreateWork = async (data) => {
    if (!workoutData.name) {
      toast.error("Please fill out workout name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!workoutData.duration) {
      toast.error("Please fill out workout duration", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!workoutData.workout_type) {
      toast.error("Please select workout type", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!workoutData.days) {
      toast.error("Please select workout days", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setisLoading(true);
      try {
        const result = await Services.createWorkoutt(data);
        if (result.status === 200) {
          setWorkoutExercise((prevData) => ({
            ...prevData,
            workout_id: result?.data?.data?.id,
          }));
          workoutDetail(result?.data?.data?.id);
          localStorage.setItem("workoutId", result?.data?.data?.id);
         
          if (selectedVideoFile) {
            setShowVideoUploadPopup(true);
          } else {
            toast.success(result?.data?.message, {
              autoClose: 2000,
              pauseOnHover: true,
              draggable: true,
              position: toast.POSITION.TOP_CENTER,
            });
          }
          setisdisable(false);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const EditWork = async (data) => {
    setisLoading(true);
    try {
      const result = await Services.editWorkoutt(data);
      if (result.status === 200) {
        if (selectedVideoFile) {
          setShowVideoUploadPopup(true);
        } else {
          toast.success("Workout updated successfuly", {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  
  const showActionModal = () => {
    return (
      <ErrorModal 
        handleOK={exerciseOps.handleActionConfirmed}
        errorMessage={actionModalMessage}
        setErrorMessage={setActionModalMessage}
        setErrorModal={setConfirmActionModal}
        actionButtonTitle={actionButtonTitle}
      />
    );
  };

  // Payload objects
  const mergePayLoad = {
    id: 0,
    workout_id: wid || widd,
    program_id: pid,
    video: mvideo ? mvideo : "",
    add_exercises: selectedExerciseIds ? selectedExerciseIds : [],
    remove_exercises: selectedExerciseremoveIds ? selectedExerciseremoveIds : [],
  };

  const removePayLoad = {
    id: mergeId,
    workout_id: wid || widd,
    program_id: pid,
    video: mvideo ? mvideo : "",
    add_exercises: selectedExerciseIds ? selectedExerciseIds : null,
    remove_exercises: selectedExerciseremoveIds ? selectedExerciseremoveIds : [],
  };

  useEffect(() => {
    workoutDetail(wid);
    programmDetail(pid);
  }, []);

  useEffect(() => {
    allExcercises(1, keyword);
    generalField();
  }, [cmodal, keyword]);

  // Close handler for VideoUploadPopup
  const handleCloseVideoUploadPopup = () => {
    setShowVideoUploadPopup(false);
    if (videoUploadContext === 'exercise') {
      pendingExerciseRef.current = null;
      setVideoUploadContext(null);
      setSelectedVideoFile(null);
      setSelectedVideoUrl(null);
    }
  };

  return (
    <>
      <div className="wrapper-dashboard create-workout">
        {confirmActionModal && showActionModal()}

        <ExerciseSetModal
          selectedExercise={selectedExercise}
          selectedExerciseEmom={selectedExerciseEmom}
          emomIterations={emomIterations}
          handleModalClose={exerciseOps.handleModalClose}
          handleModalCloseEmom={exerciseOps.handleModalCloseEmom}
          handleAddSetClick={exerciseOps.handleAddSetClick}
          handleSaveSet={exerciseOps.handleSaveSet}
          handleSaveSetEmom={exerciseOps.handleSaveSetEmom}
          handleSetChange={handleSetChange}
          handleSetChangeEmom={handleSetChangeEmom}
          deleteSets={exerciseOps.deleteSets}
          wid={wid}
          widd={widd}
        />

        <QuickEditModal
          quickset={quickset}
          setQuickSet={setQuickSet}
          apiexercises={apiexercises}
          inputValues={inputValues}
          handleInputsChange={handleInputsChange}
          handleQuickSaveSet={exerciseOps.handleQuickSaveSet}
        />

        <CreateExerciseModal
          cmodal={cmodal}
          setCmodal={setCmodal}
          newExercise={newExercise}
          handleNewExerciseChange={handleNewExerciseChange}
          generalFields={generalFields}
          selectedFields={selectedFields}
          handleFieldSelection={handleFieldSelection}
          createNewExercise={createNewExercise}
          // Pass video upload props similar to WorkoutForm
          selectedVideoUrl={selectedVideoUrl}
          handleDivClick={handleDivClick}
          fileInputRef={fileInputRef}
          handleSelectVideo={handleSelectVideo}
          isUpLoading={isUpLoading}
          progress={progress}
        />

        <ExerciseSelectionModal
          excercisemodal={excercisemodal}
          setExcerciseModal={setExcerciseModal}
          workoutExercise={workoutExercise}
          addExcercises={addExcercises}
          excerciseList={excerciseList}
          keyword={keyword}
          setkeyword={setkeyword}
          toggleExercise={toggleExercise}
          isSelectedExercise={isSelectedExercise}
        />

        <MergeExerciseModal
          merge={merge}
          setMerge={setMerge}
          removeMerge={removeMerge}
          setRemoveMerge={setRemoveMerge}
          mvideo={mvideo}
          setMvideo={setMvideo}
          mergeexercises={mergeexercises}
          apiexercises={apiexercises}
          workoutData={workoutData}
          formateSetsinputs={formateSetsinputs}
          selectedExerciseIds={selectedExerciseIds}
          selectedExerciseremoveIds={selectedExerciseremoveIds}
          handleExerciseClickk={exerciseOps.handleExerciseClickk}
          handleExerciseClickRemove={exerciseOps.handleExerciseClickRemove}
          mergeId={mergeId}
          mergeExercisesNow={exerciseOps.mergeExercisesNow}
          removeMergeNow={exerciseOps.removeMergeNow}
          mergePayLoad={mergePayLoad}
          removePayLoad={removePayLoad}
        />

        {isLoading && (
          <div className="loaderparent">
            <div className="loader"></div>
          </div>
        )}
        {isLoad && (
          <div className="loaderparent">
            <div className="loader"></div>
          </div>
        )}
        <ToastContainer />
        
        <div className="left">
          <Sidebar />
        </div>

        <div className="right">
          <WorkoutTabs
            // WorkoutForm props
            workoutData={workoutData}
            handleInputChange={handleInputChange}
            selectedDays={selectedDays}
            handleDayClick={handleDayClick}
            weeks={weeks}
            CreateWork={CreateWork}
            EditWork={EditWork}
            isdisable={isdisable}
            wid={wid}
            widd={widd}
            pid={pid}
            handleImageFileChange={handleImageFileChange}
            selectedimage={selectedimage}
            image={image}
            placholder={placholder}
            getImageUrl={getImageUrl}
            BASE_URL_MEDIA={BASE_URL_MEDIA}
            selectedVideoUrl={selectedVideoUrl}
            handleDivClick={handleDivClick}
            fileInputRef={fileInputRef}
            handleSelectVideo={handleSelectVideo}
            isUpLoading={isUpLoading}
            progress={progress}
            ProgressBar={ProgressBar}
            
            // Exercise props
            setCmodal={setCmodal}
            showExcercise={showExcercise}
            apiexercises={apiexercises}
            setReorder={setReorder}
            openMergeModal={exerciseOps.openMergeModal}
            reorder={reorder}
            mergeexercises={mergeexercises}
            formateSetsinputs={formateSetsinputs}
            addType={addType}
            setAddType={setAddType}
            setQuickSet={setQuickSet}
            handleExerciseClick={exerciseOps.handleExerciseClick}
            handleAddType={handleAddType}
            deleteEx={exerciseOps.deleteEx}
            duplicateEx={exerciseOps.duplicateEx}
            openRemoveModal={exerciseOps.openRemoveModal}
            reOrderexcercise={reOrderexcercise}
            payLoad={payLoad}
            onDragEnd={onDragEnd}
            detailset={detailset}
          />
        </div>

        {showVideoUploadPopup && selectedVideoFile && (
          <VideoUploadPopup
            videoFile={selectedVideoFile}
            workoutId={wid || widd}
            onClose={handleCloseVideoUploadPopup}
            onVideoUploaded={videoUploadContext === 'exercise' ? handleExerciseVideoUploaded : handleVideoUploaded}
          />
        )}
      </div>
    </>
  );
};

export default CreateWorkout;
